export default __webpack_public_path__ + "static/media/FancyMaroonGoldPlatedPolaBangles.5df42ca2.jpg";